import React from 'react'
import { FaBuilding, FaGraduationCap, FaLeaf, FaUserAlt, FaUsers } from 'react-icons/fa'
import { Wrapper } from '../_components'
import Axios from 'axios'
import { Chart } from "react-google-charts";


export const SexOptions = {
  title: "Sex Summary",
};

export const GenderOptions = {
  title: "Gender Summary",
};

export default function Dashboard( {} ) {
  const [ summary, setSummary ] = React.useState({} )
  const [ loading, setLoading ] = React.useState( true )

  React.useEffect( () => {
   if( loading ) {
    getDepedencies()
   }
  },[ loading ])

  async function getDepedencies() {
    try {
      const response = await Axios.get( `https://mis.nec.go.ug/api/auth/fiefoc_report/${localStorage.getItem( "scheme" ).replace( "_", " ")}` )
      if( response.data ) {

        //aggregate the results
        setSummary( {
          farmers: response.data.all_farmers.map( item => item.no )?.[ 0 ],
          groups: response.data.groups.length,
          plots: response.data.plots[ 0 ]?.no,
          blocks: response.data.blocks.length,
          gender: response.data.gender.map( ( item, index ) => {
            return { 
              id: index+1, 
              label: `${item.gender}`, 
              count: item.no 
            }
          } ),
          sex: response.data.sex.map( ( item, index ) => {
            return { 
              id: index+1, 
              label: `${item.sex}`, 
              count: item.no 
            }
          } ),
        } )
        setLoading( false )
      }
    } catch (error) {}
  }

  if( !summary ) {
    return (
      <Wrapper>
        <div className="text-base text-center text-black">
          {`Loading the Summary Data..`}
        </div>
      </Wrapper>
    )
  }

  let chartSummary = {
    man: summary.gender?.filter( item => item.label === "Man")?.[ 0 ]?.count,
    woman: summary.gender?.filter( item => item.label === "Woman")?.[ 0 ]?.count,
    youth: summary.gender?.filter( item => item.label === "Youth")?.[ 0 ]?.count,
    males: summary.sex?.filter( item => item.label === "Male" )?.[ 0 ]?.count,
    females: summary.sex?.filter( item => item.label === "Female" )?.[ 0 ]?.count
  }

  return (
    <Wrapper>
      {loading ? <div>{`Loading results...`}</div> : (
        <div className="flex flex-col md:grid md:grid-rows-2  lg:grid-rows-2 md:gap-1 lg:gap-1 w-full">
        <div className="h-auto grid md:grid-cols-3 md:gap-2 lg:grid-cols-3 lg:gap-3">
          <BoardCard label="Total Number of Registered Farmers" count={summary?.farmers} icon={<FaUsers size={20} color={`#FFF`} />} color={`#3f84fc`}/>
          <BoardCard label="Total Number of Blocks" count={summary?.blocks} icon={<FaBuilding size={20} color={`#FFF`} />} color={`#1dab47`}/>
          <BoardCard label="Total Number of FFS Groups" count={summary?.groups} icon={<FaGraduationCap size={20} color={`#FFF`} />} color={`#8b3ffc`}/>
          <BoardCard label="Number of Plots" count={summary?.plots} icon={<FaLeaf size={20} color={`#FFF`} />} color={`#738094`} />
        </div>
        <div className="border-red-500 h-auto grid grid-cols-1 md:grid-cols-2 md:gap-2 lg:grid-cols-2 lg:gap-3">
          <Chart
            chartType="PieChart"
            data={[
              ["Gender", "Count"],
              ["Man", chartSummary.man ],
              ["Woman", chartSummary.woman ],
              ["Youth", chartSummary.youth ]
            ]}
            options={GenderOptions}
            width={"100%"}
            height={"300px"} />

          <Chart
            chartType="PieChart"
            data={[
              ["Sex", "Count"],
              ["Males", chartSummary.males ],
              ["Females", chartSummary.females ]
            ]}
            options={SexOptions}
            width={"100%"}
            height={"300px"} />
        </div>
      </div>
      ) }
    </Wrapper>
  )
}

const BoardCard = ( { label, icon, count, color, content, black } ) => {
  return (
    <div className="h-32 flex flex-col shadow-xl px-3 py-2 rounded my-2" style={{ backgroundColor: color }}>
        <div className="h-3/5 flex items-center">
          <h2 className={` ${ black ? `text-black` : `text-white` } text-lg text-start font-bold`}>{label}</h2>
        </div>
        {/* {content && content.length > 0 ? (
          <div className="flex flex-col justify-center w-full">
            {content.map( item => {
              return (
                <div key={item.id} className="w-full flex flex-row items-center justify-between">
                  <span className="text-center text-base font-bold">{item.label}</span>
                  <span className="text-center text-base font-bold">{item.count}</span>
                </div>
              )
            } )}
          </div>
        ) :
        (  */}
        <div className="flex-grow flex items-center justify-between px-2">
          <div>{icon}</div>
          <span className="text-base font-bold text-white">
            {count}
          </span>
        </div> 
    </div>
  )
}